import { RouterProvider } from 'react-router-dom'
import './App.css'
import router from '@routes/routes.jsx'
import { useEffect } from 'react'
import { initializeMStockTheme } from '@utils/mStockTheme.js'
import { MStockThemeTestToggle } from '@components/organism/mStock/MStockThemeTestToggle.jsx'

const SERVICE_THEME = {
  ASP: { themeClass: 'theme-kbpay', supportsDarkMode: false },
  MSTOCK: { themeClass: 'theme-mstock', supportsDarkMode: true },
  hana: { themeClass: 'theme-hana', supportsDarkMode: true },
  jb: { themeClass: 'theme-jb', supportsDarkMode: false }
}

const { themeClass: THEME_CLASS, supportsDarkMode: SUPPORTS_DARK_MODE } =
  SERVICE_THEME[__APP_TARGET__] ?? SERVICE_THEME.ASP

const SHOW_MSTOCK_THEME_TESTER =
  SUPPORTS_DARK_MODE && import.meta.env.VITE_SHOW_MSTOCK_THEME_TESTER === 'true'

function App() {
  const isWidget = window.location.pathname.startsWith('/widgets/')

  useEffect(() => {
    sessionStorage.removeItem('__CHUNK_RELOAD__')
  }, [])

  useEffect(() => {
    if (!SUPPORTS_DARK_MODE || isWidget) {
      return
    }

    return initializeMStockTheme()
  }, [isWidget])

  return (
    <>
      <div
        id={isWidget ? 'widget-container' : 'container'}
        className={isWidget ? undefined : THEME_CLASS}
      >
        <RouterProvider router={router} />
      </div>

      {SHOW_MSTOCK_THEME_TESTER && <MStockThemeTestToggle />}
    </>
  )
}

export default App
